import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import UnderConstruction_zn from "../container/Blank/UnderConstruction_zn";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Accommodation = () => {
  const show=false;
  if(show)
  {
    
    return (
      <React.Fragment>
        <SEO title="住宿 | ICSI 2022" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="住宿"
          content="中文参会通道"
          contentTwo="住宿"
          linkage="/"
        />
  
        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content">
            <h3 align="center" className="STYLE3">
              Reserving a Room at Venue Hotel{" "}
              <a href="http://www.lanhai.cn/fHotel/hotelIntroduce?id=11221">
                Qingdao Blue Horizon Hotel Laoshan (青岛蓝海大饭店（崂山）){" "}
              </a>
              !
            </h3>
            <p align="left">
              <br />
              1. All participants are highly recommendated to make a reservation
              at Qingdao Blue Horizon Hotel Laoshan in Qingdao.
              <br />
              2.Considering July is a tourism-peak season of Qingdao, it&apos;s
              may hard for you to find an available accommodation with reasonable
              price nearby the venue hotel, the secretariat offers our
              participants a reservation service.
              <br />
              3. We highly recommend our participants make your reservation ASAP
              before July 9th 23:59:59 GMT+8! It is very convenient for you to
              attend our technical/social acitvities during the confenerce.
              <br />
              4. We provide an official WeChat group for participants to
              communicate, if you are looking for a roommate during conference,
              please scan the following QR code.
              <br />
              <p align="center">
                <img src="./wechat.jpg" alt="" width="200px" />
              </p>
            </p>
  
            <div className="entry-content">
              <h4>
                <b>
                  More about accommodation: Please download the{" "}
                  <a href="./酒店简介.pdf" target="_blank">
                    hotel introduction.
                  </a>
                </b>
              </h4>
              <br></br>
              <p>
                Blue Horizon Hotel (Qingdao Shilaoren International Exhibition
                Center store) is affiliated to Shandong Blue Horizon Hotel Group,
                located in Laoshan District, Qingdao City, and shilao tourist
                resort in the south. It is an important part of Shandong
                International Conference and Exhibition Center. The rooms are
                distributed on the 3rd to 9th floors, with spacious and bright
                rooms, equipped with complete equipment such as broadband network,
                satellite TV, international direct dial telephone, small bar,
                electronic safe, etc., and equipped with transparent toilet and
                modern home facilities, showing luxury and fashion. It is an ideal
                choice for you to stay in business and life.
              </p>
              <div className="row">
                <img src="http://www.lanhai.cn/LHJD/outImages/hotel/20201118155129024_2304754.jpg" />
                <img src="http://www.lanhai.cn/LHJD/outImages/hotel/20170223140051718_6829513.jpg" />
                <img src="http://www.lanhai.cn/LHJD/outImages/hotel/20170223140004328_9545455.jpg" />
                <img src="http://www.lanhai.cn/LHJD/outImages/hotel/20170223135426890_467185.jpg" />
              </div>
            </div>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
  else
  {
    return (
      <React.Fragment>
        <SEO title="住宿 | ICSI 2022" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="住宿"
          content="中文参会通道"
          contentTwo="住宿"
          linkage="/"

        />
  
        {/* <HomeAbout /> */}
        <EmptyTwo>
          <UnderConstruction_zn/>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
};

export default Accommodation;
